import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Loading, SelectMenu } from 'components/patterns'

const HEADER_FOOTER_OFFSET = 280

export const AdvancedSearchWrap = styled.div`
  overflow-y: auto;
  max-height: calc(100vh - ${HEADER_FOOTER_OFFSET}px);
`

export const StyledLoading = styled(Loading)`
  margin-bottom: 8px;
`

export const StyledSelectMenu = styled(SelectMenu)`
  margin-bottom: 8px;
  .ant-select {
    width: 295px;
  }
`

export const ClearFilters = styled.span`
  font-size: 12px;
  &:hover {
    color: ${themeColor('clearFiltersBtnIconColor')};
  }
  padding-right: 5px;
  cursor: pointer;
`

export const AdvancedSearchArea = styled.div`
  margin-top: 16px;
`

export const AdvancedSearchFiltersHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
